import { render, staticRenderFns } from "./CreateLayoutFolderModal.vue?vue&type=template&id=268a938a&scoped=true"
import script from "./CreateLayoutFolderModal.vue?vue&type=script&lang=js"
export * from "./CreateLayoutFolderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268a938a",
  null
  
)

export default component.exports